export enum Page {
    Story = 'story',
    Details = 'details',
    RSVP = 'rsvp',
    WeddingPartyInfo = 'wpinfo'
};